// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function betweenSelectedMonthsClass(className, startMonth, endMonth, stage, hoveredMonth, month) {
  switch (stage) {
    case /* Default */ 0 :
      if (startMonth !== undefined && endMonth !== undefined) {
        return Cn.on(className, Caml_obj.caml_greaterthan(month, Caml_option.valFromOption(startMonth)) && Caml_obj.caml_lessthan(month, Caml_option.valFromOption(endMonth)));
      } else {
        return "";
      }
    case /* StartDaySelecting */ 1 :
    case /* EndDaySelecting */ 2 :
      return "";
    case /* StartMonthSelecting */ 3 :
      if (startMonth !== undefined && hoveredMonth === undefined) {
        if (endMonth !== undefined) {
          return Cn.on(className, Caml_obj.caml_greaterthan(month, Caml_option.valFromOption(startMonth)) && Caml_obj.caml_lessthan(month, Caml_option.valFromOption(endMonth)));
        } else {
          return "";
        }
      }
      if (hoveredMonth !== undefined && endMonth !== undefined) {
        return Cn.on(className, Caml_obj.caml_greaterthan(month, Caml_option.valFromOption(hoveredMonth)) && Caml_obj.caml_lessthan(month, Caml_option.valFromOption(endMonth)));
      } else {
        return "";
      }
    case /* EndMonthSelecting */ 4 :
      if (startMonth === undefined) {
        return "";
      }
      const startMonth$1 = Caml_option.valFromOption(startMonth);
      if (hoveredMonth !== undefined) {
        return Cn.on(className, Caml_obj.caml_greaterthan(month, startMonth$1) && Caml_obj.caml_lessthan(month, Caml_option.valFromOption(hoveredMonth)));
      } else if (endMonth !== undefined) {
        return Cn.on(className, Caml_obj.caml_greaterthan(month, startMonth$1) && Caml_obj.caml_lessthan(month, Caml_option.valFromOption(endMonth)));
      } else {
        return "";
      }
  }
}

const Utils = {
  betweenSelectedMonthsClass: betweenSelectedMonthsClass
};

const container = "grid grid-cols-3 gap-px bg-white-12 rounded-sm border border-solid border-white-12";

const animate = "animate-fadeScaleIn";

const cell = "w-24 h-10 text-center bg-black flex items-center justify-center hover:bg-secondary cursor-pointer";

const cell__selected = "bg-secondary";

const cell__disabled = "pointer-events-none";

const Styles = {
  container: container,
  animate: animate,
  cell: cell,
  cell__empty: "w-24 h-16 bg-black",
  cell__selected: cell__selected,
  cell__today: "bg-success",
  cell__disabled: cell__disabled
};

function getMonths(year, month, selectedStartMonth, selectedEndMonth, hoveredMonth, setHoveredMonth, stage, onMonthSelected, param) {
  const monthNames = {
    hd: "Январь",
    tl: {
      hd: "Февраль",
      tl: {
        hd: "Март",
        tl: {
          hd: "Апрель",
          tl: {
            hd: "Май",
            tl: {
              hd: "Июнь",
              tl: {
                hd: "Июль",
                tl: {
                  hd: "Август",
                  tl: {
                    hd: "Сентябрь",
                    tl: {
                      hd: "Октябрь",
                      tl: {
                        hd: "Ноябрь",
                        tl: {
                          hd: "Декабрь",
                          tl: /* [] */ 0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  let monthNameDivs = /* [] */ 0;
  for (let i = 1, i_finish = Belt__Belt_List.length(monthNames); i <= i_finish; ++i) {
    const currentDt = DateTime.local(year, i, undefined, undefined, undefined, undefined, undefined, undefined);
    const month$1 = Belt__Belt_List.get(monthNames, i - 1 | 0);
    if (month$1 !== undefined) {
      const Key = "month-" + String(i);
      const monthNameDiv = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          className: Cn.fromList({
            hd: DateTime.compare(currentDt, DateTime.startOf("month", DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))) > 0 ? "text-gray-medium" : "text-white",
            tl: /* [] */ 0
          }),
          children: month$1
        }),
        className: Cn.fromList({
          hd: cell,
          tl: {
            hd: Cn.on(cell__disabled, DateTime.compare(currentDt, DateTime.startOf("month", DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))) > 0),
            tl: {
              hd: Cn.mapSome(selectedStartMonth, (function (selectedStartMonth) {
                return Cn.on(cell__selected, Caml_obj.caml_equal(selectedStartMonth, currentDt));
              })),
              tl: {
                hd: Cn.mapSome(selectedEndMonth, (function (selectedEndMonth) {
                  return Cn.on(cell__selected, Caml_obj.caml_equal(selectedEndMonth, currentDt));
                })),
                tl: {
                  hd: betweenSelectedMonthsClass("cell__between__selected", selectedStartMonth, selectedEndMonth, stage, hoveredMonth, currentDt),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }),
        onClick: (function (param) {
          Curry._1(onMonthSelected, currentDt);
        }),
        onMouseEnter: (function (param) {
          Curry._1(setHoveredMonth, (function (param) {
            return Caml_option.some(currentDt);
          }));
        }),
        onMouseLeave: (function (param) {
          Curry._1(setHoveredMonth, (function (param) {
            
          }));
        })
      }, Key);
      monthNameDivs = Stdlib.$at(monthNameDivs, {
        hd: monthNameDiv,
        tl: /* [] */ 0
      });
    }
    
  }
  return monthNameDivs;
}

const make = React.forwardRef(function (Props, ref_) {
  let year = Props.year;
  let month = Props.month;
  let selectedStartMonth = Props.selectedStartMonth;
  let selectedEndMonth = Props.selectedEndMonth;
  let onMonthSelectedOpt = Props.onMonthSelected;
  let stageOpt = Props.stage;
  const onMonthSelected = onMonthSelectedOpt !== undefined ? onMonthSelectedOpt : (function (param) {
      
    });
  const stage = stageOpt !== undefined ? stageOpt : /* Default */ 0;
  const match = React.useState(function () {
    return container;
  });
  const setContainerClasses = match[1];
  const selectedStartMonth$1 = Belt__Belt_Option.map(selectedStartMonth, (function (param) {
    return DateTime.startOf("month", param);
  }));
  const selectedEndMonth$1 = Belt__Belt_Option.map(selectedEndMonth, (function (param) {
    return DateTime.startOf("month", param);
  }));
  const match$1 = React.useState(function () {
    
  });
  React.useEffect((function () {
    Curry._1(setContainerClasses, (function (param) {
      return Cn.fromList({
        hd: container,
        tl: {
          hd: animate,
          tl: /* [] */ 0
        }
      });
    }));
    const animate$1 = setTimeout((function (param) {
      Curry._1(setContainerClasses, (function (param) {
        return container;
      }));
    }), 300);
    return (function (param) {
      clearTimeout(animate$1);
    });
  }), [
    month,
    year
  ]);
  let dt;
  let exit = 0;
  if (month !== undefined && year !== undefined) {
    dt = DateTime.local(year, month, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    exit = 1;
  }
  if (exit === 1) {
    dt = DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
  let tmp = {
    children: Belt__Belt_List.toArray(getMonths(DateTime.year(dt), DateTime.month(dt), selectedStartMonth$1, selectedEndMonth$1, match$1[0], match$1[1], stage, onMonthSelected, undefined)),
    className: match[0]
  };
  const tmp$1 = Belt__Belt_Option.map((ref_ == null) ? undefined : Caml_option.some(ref_), (function (prim) {
    return prim;
  }));
  if (tmp$1 !== undefined) {
    tmp.ref = Caml_option.valFromOption(tmp$1);
  }
  return JsxRuntime.jsx("div", tmp);
});

export {
  Utils,
  Styles,
  getMonths,
  make,
}
/* make Not a pure module */
